import React from 'react';
import { useIntl } from 'umi';

export function Content(props: { title: 'sum' | (string & {}) }) {
  const { title } = props;
  const { formatMessage } = useIntl();
  let tip: React.ReactNode = '';
  switch (title) {
    case 'sum':
      tip = formatMessage({ id: 'dbi_info_sum_selected' });
      break;
    case 'avg':
      tip = formatMessage({ id: 'dbi_info_avg_selected' });
      break;
    case 'peak':
      tip = formatMessage({ id: 'dbi_info_streaming_peakccv' }) + formatMessage({ id: 'dbi_info_max_selected' });
      break;
    default:
      tip = '';
      break;
  }
  return <>{tip}</>;
}